import axios from "axios";
import {API} from "../config";

const path = "/servico-acolhimento";

class PerfilSAService {
  novaPerfilSA(id, perfilSA){
    return axios.post(API + path + `/${id}/perfil`, perfilSA);
  }

  getPerfilSA(id){
    return axios.get(API + path + `/${id}/perfil`)
  }

  atualizarPerfilSA(id, perfilSA){
    return axios.put(API + path + `/${id}/perfil`, perfilSA);
  }
}

const instancePerfilSA = new PerfilSAService();
export default instancePerfilSA;